import { render, staticRenderFns } from "./explore_recommend_list.vue?vue&type=template&id=e15b52b4"
import script from "./explore_recommend_list.vue?vue&type=script&lang=js"
export * from "./explore_recommend_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports